<script setup>
import { ref } from 'vue'

import { getI18n } from '@/plugins/i18n'

import { useAccountingStore } from '@/stores/accounting.store'

import ConfirmDialog from '@/components/shared/ConfirmDialog.vue'

const props = defineProps({
  invoice: {
    type: Object,
    default: null,
  },
})

const emit = defineEmits(['deleted', 'cancel'])

const i18n = getI18n()
const accountingStore = useAccountingStore()

const isWarningStep = ref(false)

const close = (event, ...args) => {
  isWarningStep.value = false
  emit(event, ...args)
}

const onDeleteConfirmed = async () => {
  await accountingStore.deleteInvoiceAsync(props.invoice.id)
  close('deleted', props.invoice.id)
}
</script>

<template>
  <confirm-dialog
    :model-value="invoice !== null && !isWarningStep"
    :message="i18n.t('common.confirmDeleteMessage', { item: invoice?.invoice_number })"
    @confirm="isWarningStep = true"
    @cancel="close('cancel')"
  />
  <confirm-dialog
    :model-value="invoice !== null && isWarningStep"
    :message="i18n.t('warning.deleteInvoiceUnlinksRows')"
    icon="mdi-alert"
    icon-color="warning"
    icon-size="md"
    @confirm="onDeleteConfirmed"
    @cancel="close('cancel')"
  />
</template>
